import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
// import moment from 'moment';

interface BatchesManagerState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
    meta: any;
}

const state: BatchesManagerState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
    meta: null,
};

export const ITEMS_LIST = 'GET_CITY_LIST';
export const GET_SCHEMA = 'GET_SCHEMA';

export const actions: ActionTree<BatchesManagerState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                "id": "batches.id",
                "name": "vi.name",
                "total_weight": "batches.total_weight",
                "manufacturer_name": "m.name",
                "datetime": "batches.datetime",
                "batch_number": "batches.batch_number",
                "provider_name": "vp.name",
            };

            const filter: any[] = [];

            if (query.name) {
                filter.push({ "$ilike": ["batches.name", {"$": `%${query.name}%`}] })
            }
            const orders: any[] = [];

            if (query.sortFields) {
                JSON.parse((query.sortFields)).map((item: any) => {
                    orders.push(item.order == 'desc' ? { $desc: [columns[item.field || 'name' ]] } : { $asc: [columns[item.field || 'name']] })
                })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    "from": "s:batches",
                    "from_as": "batches",
                    joins: [
                        {
                            join: 's:voc_manufacturers',
                            as: 'm',
                            type: 'left',
                            on: {
                                $eq: ['batches.manufacturer_id', 'm.id']
                            }
                        },
                        {
                            join: 's:voc_ingredients',
                            as: 'vi',
                            type: 'left',
                            on: {
                                $eq: ['batches.ingredient_id', 'vi.id']
                            }
                        },
                        {
                            join: 's:voc_providers',
                            as: 'vp',
                            type: 'left',
                            on: {
                                $eq: ['batches.provider_id', 'vp.id']
                            }
                        }
                    ],
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: orders
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                }),
                vm.$q(GET_SCHEMA)
                .raw('schemas.get')
                .action({
                    id: `s:batches`
                }),
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('SET_SCHEMA', result.getOperation(GET_SCHEMA).getContent().schema);
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    saveTodoType({ commit, getters, dispatch }, data) {
        const vm = (this as any)._vm;

        const query = data.id ?
            vm.$q('SAVE_DOCUMENT').update(data.id, data) :
            vm.$q('SAVE_DOCUMENT').create('batches', data);

        return new Promise((resolve, reject) => {
            vm.$db([
                query
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('SAVE_DOCUMENT');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

};

export const mutations: MutationTree<BatchesManagerState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
    SET_SCHEMA(state, schema) {
        state.meta = fetchEnumsFromSchema(schema);
    },
};

const getters = {

};

export const STORE_KEY = '$_batches_manger';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
